<template>
	<modal
		id="modal"
		:class="[
			getModuleObj.size ? `modal--${getModuleObj.size}` : '',
			{ 'modal--full-height': getModuleObj.fullHeight },
		]"
		@close="close"
		transition="fade"
		:visible="isOpen"
		:closable="true"
	>
		<div class="modal-box">
			<header class="modal-box__header" v-if="modalTitle">
				{{ modalTitle }}
			</header>
			<div class="modal-box__conts">
				<h2
					class="modal-box__conts__title"
					v-if="getContsTitle"
					v-html="getContsTitle"
				></h2>
				<button
					class="btn modal-box__conts__btn-close"
					type="button"
					v-if="getModuleObj.hasXBtn"
					@click="close"
				>
					<i
						class="modal-box__conts__btn-close__icon fa fa-times"
						aria-hidden="true"
					></i>
				</button>
				<component
					:is="getModuleObj.module"
					:params="params || {}"
					ref="targetModal"
					@close="close"
				/>
			</div>
			<div class="btn-wrap-main" v-if="getModuleObj.mainBtnText">
				<button class="btn-main blue" type="button" @click="add">
					{{ getModuleObj.mainBtnText[0] }}
				</button>
				<button
					class="btn-main blue bordered"
					type="button"
					@click="close"
				>
					{{ getModuleObj.mainBtnText[1] }}
				</button>
			</div>
		</div>
	</modal>
</template>
<script>
	import { Modal } from 'vue-bulma-modal';
	import { mapState } from 'vuex';
	import modalData from './index.js';

	export default {
		name: 'ModalBox',
		components: { Modal },
		computed: {
			...mapState('modal', [
				'isOpen',
				'id',
				'modalTitle',
				'contsTitle',
				'params',
			]),
			getModuleObj() {
				return modalData[this.id];
			},
			getContsTitle() {
				return this.contsTitle || this.getModuleObj.contsTitle;
			},
		},
		methods: {
			close() {
				this.$store.commit('modal/toggleModal', false);
				this.$store.commit('toggleSpinner', false);
			},
			async add() {
				this.$store.commit('toggleSpinner', true);
				const isComplete = await this.$refs.targetModal.add();
				if (isComplete) this.close();
			},
		},
		beforeDestroy() {
			this.$store.commit('modal/init');
		},
	};
</script>

<style lang="scss">
	#modal {
		.modal-close {
			display: none;
		}

		.modal-box {
			background-color: #f4f4f4;

			.modal-box__header {
				width: 100%;
				height: 56px;
				background: #495470;
				line-height: 56px;
				text-align: center;
				color: #fff;
				font-size: 1.375rem;
				font-weight: 700;
			}

			.modal-box__conts {
				width: 100%;
				background-color: #fff;
				padding: 40px;
				border-bottom: solid 1px #ebebed;
			}

			.modal-box__conts__title {
				padding-right: 30px;
				padding-bottom: 12px;
				border-bottom: solid 1px #ebebed;
				line-height: 26px;
				color: #303643;
				font-size: 1.625rem;
				font-weight: bold;
				word-break: break-all;
			}

			.modal-box__conts__btn-close {
				position: absolute;
				top: 40px;
				right: 40px;
				width: 27px;
				height: 27px;
				padding: 0;
				border: none;
				border-radius: 0;

				&:before {
					margin: 0;
				}

				&:after {
					display: none;
				}
			}

			.modal-box__conts__btn-close__icon {
				cursor: pointer;
				font-size: 1.5rem;
			}

			.managing-section.list-row .box__contswrap {
				padding: 6px;
			}
		}

		&.modal--wide {
			.modal-container {
				width: 100%;
			}

			.modal-content {
				width: 960px;
			}
		}

		&.modal--web-preview .modal-content {
			width: 457px;
		}

		&.modal--full-height {
			.modal-content {
				height: calc(100vh - 40px);
			}

			.modal-box {
				height: 100%;
			}

			.modal-box__conts {
				position: relative;
				height: 100%;
				padding-top: 79px !important;
				overflow-y: auto;
			}

			.modal-box__conts__title {
				position: absolute;
				display: block;
				width: 100%;
				padding: 40px 40px 0 40px !important;
				top: 0;
				left: 0;
				border: 0 !important;

				&:after {
					content: '';
					display: block;
					width: 100%;
					height: 1px;
					margin: 12px 0 0 0;
					background: #ebebed;
				}
			}
		}
	}
</style>
